@import 'vars';

.support-footer {
  position: sticky;
  background: white;
  gap: $gap-xsmall;
  left: 0;
  right: 0;
  bottom: 0px;
  margin-inline: auto;
  width: 100%;
  z-index: 1000;
  text-align: center;

  &__label {
    display: flex;
    gap: 4px;
    align-items: flex-end;
  }

  &__icon {
    color: $primary;
  }
}
